import { 
    SET_PRODUCT_TYPES
} from '../actions/action-types';


// Inital zoom and center
const initialState = {
    product_types: null
};

export default function(state = initialState, action:any){
    switch(action.type){
        case SET_PRODUCT_TYPES:
            return{
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}